import { AddClickTraceHandler } from "./click-trace";
import { AddEscapeHandler, RemoveEscapeHandler } from "./escape-handlers";

function AP_HideSideBar() {
  RemoveEscapeHandler(AP_HideSideBar);
  document.querySelector('body').classList.remove('show-sidebar');
}
function ToggleSideBar() {
  let b=document.querySelector('body.adminpanel');
  if(!b) return;
  if(b.classList.contains("show-sidebar")) {
    AP_HideSideBar();
  } else {
    AddEscapeHandler(AP_HideSideBar);
    b.classList.add('show-sidebar');
  }
}

AddClickTraceHandler((el:HTMLElement,evt:Event)=> el.dataset.toggle==='sidebar',ToggleSideBar);
AddClickTraceHandler((el:HTMLElement,evt:Event)=> el.dataset.dismiss==='sidebar',AP_HideSideBar);
